import {RangeOption, ValidationErrors} from '../types/VolPerfRange.types';

export const RANGE_OPTIONS: RangeOption[] = [
  {text: 'Above', id: 'above', defaultVal: true},
  {text: 'Below', id: 'below', defaultVal: false},
  {text: 'Between', id: 'between', defaultVal: false},
];

export const EMPTY_ERRORS: ValidationErrors = {
  rangeValue: '',
  minValue: '',
  maxValue: '',
};

export const INVALID_SINGLE_VALUE_ERROR = 'Please enter valid value';
export const NUMERIC_ONLY_ERROR = 'Please enter numeric values only';
export const MIN_VALUE_ERROR = 'Enter minimum value';
export const MAX_VALUE_ERROR = 'Enter maximum value';
export const MIN_MAX_ORDER_ERROR = 'Min must be less than max';
export const MAX_MIN_ORDER_ERROR = 'Max must be greater than min';
export const TWO_DECIMAL_ERROR = 'Only up to 2 decimal places allowed';
export const TWO_DECIMAL_REGEX = /^-?\d*(\.\d{0,2})?$/;
